import { memo } from "react";
import { Onboarding } from "../common";
import {
    BusinessInformationLabel,
    DirectorsAndShareholdersLabel,
    FinancialInformationLabel,
    PaymentMethodsLabel,
    RiskAndComplianceLabel,
    MarketingWebsiteAndSupportLabel,
    UploadDocumentsLabel
} from "./steps";
import { useOnboardingApplication } from "./hooks";
import { WebRoutes } from "consts/enpoints/web";

const OnboardingHighRisk = () => {
    const {
        getApplicationModel
    } = useOnboardingApplication();

    return (
        <Onboarding
            route={WebRoutes.Onboarding.HighRiskMerchant}
            getApplicationModel={getApplicationModel}
        >
            <BusinessInformationLabel />
            <DirectorsAndShareholdersLabel />
            <FinancialInformationLabel />
            <PaymentMethodsLabel />
            <RiskAndComplianceLabel />
            <MarketingWebsiteAndSupportLabel />
            <UploadDocumentsLabel
                endAdornment={null}
                sx={{
                    gridTemplateColumns: 'auto 1fr auto'
                }}
            />
        </Onboarding>
    );
};

export default memo(OnboardingHighRisk);
